import { Injectable } from '@angular/core';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { ApiService } from 'app/modules/common/services/api.service';
import { Observable } from 'rxjs';
import API from '../../../modules/common/services/api.config.json';
import { DocEmpresa } from '../company-view-detail/models/Documentacion/DocEmpresa';


@Injectable({
  providedIn: 'root'
})
export class DocumentacionService {

  constructor(private _apiService: ApiService) {
  }


  public GetAllDocEmpresaByEmpresaId(empresaId: number) {
    let url = `${API.CompanyManagement.getAllDocEmpresaByEmpresaId}`;
    url += '?empresaId=' + empresaId + '';
    return this._apiService.get(url);
  }

  public GetTipoDocEmpresaList(): Observable<RestResponse> {
      const url = `${API.CompanyManagement.getTipoDocEmpresaList}`;
      return this._apiService.get(url);
  }

  public AddEmpresaDocument(model: DocEmpresa): Observable<RestResponse> {
      const url = `${API.CompanyManagement.addEmpresaDocument}`;
      return this._apiService.post(url, model);
  }

  public DeleteEmpresaDocument(id: number): Observable<RestResponse> {
      let url = `${API.CompanyManagement.deleteEmpresaDocument}`;
      url = url.replace('{documentId}', id.toString());
      return this._apiService.delete(url);
  }

  public GetDocEmpresaDocumentByDocumentId(id: number): Observable<RestResponse> {
      let url = `${API.CompanyManagement.getDocEmpresaDocumentByDocumentId}`;
      url += '?Id=' + id + '';
      return this._apiService.get(url);
  }
}
